import {Navigate, useLocation} from 'react-router-dom';

/**
 * RedirectToDefaultLang - redirects bare (unprefixed) paths to their /sk equivalent.
 * Preserves query string and hash.
 * @returns {JSX.Element}
 */
export default function RedirectToDefaultLang() {
    const location = useLocation();
    const path = location.pathname === '/' ? '' : location.pathname;
    return <Navigate to={`/sk${path}${location.search}${location.hash}`} replace />;
}
